import { render, staticRenderFns } from "./dataUpload.vue?vue&type=template&id=64d2ed60&scoped=true"
import script from "./dataUpload.vue?vue&type=script&lang=js"
export * from "./dataUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2ed60",
  null
  
)

export default component.exports